import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
    height: "100%",
    background: theme.kooee.backgrounds.primary
  },
  tableContainer: {
    paddingTop: '15px'
  },
  table: {
    maxWidth: "80%",
    background: theme.kooee.backgrounds.primary,
    color: theme.kooee.titles.primary,
    overflowX: 'auto',
    cursor: "pointer"
  },
  tableHead: {
    width: "13%",
    paddingTop: "30px",
    fontWeight: "bold",
    color: theme.kooee.titles.primary,
    position: 'relative'
  },
  tableHead2: {
    width: "16%",
  },
  tableHead3: {
    fontWeight: "bold",
    color: theme.kooee.titles.primary,
    cursor: "auto"
  },
  detailTitle: {
    color: "#55565A",
    padding: "25px 10px 16px 10px",
    [theme.breakpoints.up("md")]: {
      padding: "25px 0",
      fontSize: "1.25rem"
    },
  },
  selectedThCell: {
    borderTop: "3px solid #FB7906",
    borderLeft: "3px solid #FB7906",
    borderRight: "3px solid #FB7906",
  },
  selectedTdCell: {
    borderLeft: "3px solid #FB7906",
    borderRight: "3px solid #FB7906"
  },
  lastSelectedTdCell: {
    borderBottom: "3px solid #FB7906"
  },
  continueButton: {
    marginTop: theme.spacing(2),
    color: "#fff",
    backgroundColor: "#FB7906",
    '&:hover': {
      backgroundColor: '#e46b00',
      boxShadow: "0px 0px 5px #e46b00"
    },
    borderRadius: "0px 8px",
    width: "250px"
  },
  continueButtonContainer: {
    position: 'fixed',
    bottom: '20px',
    width: '100%',
  },
  detailTitle2: {
    color: "#55565A",
    [theme.breakpoints.up("md")]: {
      paddingBottom: "10px",
      fontSize: "1.25rem",
    },
    paddingBottom: "1em"
  },
  loader: {
    padding: "150px"
  },
  mobileViewCard: {
    width: '80%',
    borderRadius: 0,
    margin: 'auto',
    marginBottom: '2em',
  },
  mobileViewCardCell: {
    borderLeft: 'dashed 2px gray',
    borderBottom: 'dashed 2px gray',
  },
  mobileViewCardPkg: {
    paddingTop: '30px !important',
    paddingBottom: '30px !important',
    fontWeight: "bold",
    color: theme.kooee.titles.primary
  },
  mobileViewCardCellHeader: {
    padding: '20px !important',
    textAlign: 'right',
    fontWeight: "bold",
    color: theme.kooee.titles.primary
  },
  selectedMobileCard: {
    border: "6px solid #FB7906",
  },
  recommendedPackage: {
    background: '#FDDC3F',
    borderRadius: '3px',
    fontWeight: 'bold',
    fontSize: '10px',
    lineHeight: '11px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '3px',
    width: '80%'
  },
  recommendedPackageMobileView: {
    position: 'absolute',
    padding: '8px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    borderRadius: '60px',
    transform: 'rotate(-13.04deg)',
    fontWeight: 'bold',
    fontSize: '10px',
    lineHeight: '8px',
    height: '24px',
    left: '20px',
    top: '-5px',
    display: 'flex',
    alignItems: 'center'
  },
  mobileViewContainer: {
    paddingBottom: '60px',
    position: 'relative'
  },
  recommnededTagIcon: {
    paddingRight: '3px',
    paddingTop: '2px'
  }
}));